import dayjs from "dayjs";

import { DATE_FORMATS, TIME_FORMATS } from "@/lib/constants/dateTimeFormats";

export const formatPercentage = (value) => {
  return `${(value * 100).toFixed(1)}`;
};

export const getPaginationLabel = (t, isLoading, start, end, total) => {
  if (isLoading) {
    return t("page.analytics.messages.loadingResults");
  }

  if (total === 0) {
    return t("page.analytics.messages.noSubmissions");
  }

  return t("page.analytics.messages.showingSubmissions", {
    start,
    end,
    total,
  });
};

export const humanizeSnakeCase = (word) => {
  let wordToReturn = word.split("_").join(" ");
  wordToReturn = wordToReturn.toLowerCase();
  wordToReturn = wordToReturn[0].toUpperCase() + wordToReturn.slice(1);

  return wordToReturn;
};

export const capitalizeWord = (word) => {
  if (!word) return "";

  const words = word.split("_");
  const capitalizedWords = words.filter((w) => w.length > 0).map((w) => w[0].toUpperCase() + w.slice(1));

  return capitalizedWords.join(" ");
};

export const getSelectedDateFormatOptions = (translate) => {
  const now = dayjs();

  return Object.values(DATE_FORMATS).map((format) => {
    const label = format.labelKey && translate ? translate(format.labelKey) : format.label;

    return {
      text: label,
      value: format.value,
      example: now.format(format.pattern),
    };
  });
};

export const maskApiKey = (key) => {
  if (!key || key.length <= 17) {
    return key || "";
  }

  const start = key.substring(0, 8);
  const end = key.substring(key.length - 4);

  return `${start}${"•".repeat(5)}${end}`;
};

export const formatBytes = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

export const getSelectedTimeFormatOptions = (translate) => {
  const now = dayjs();

  return Object.values(TIME_FORMATS).map((format) => {
    const label = format.labelKey && translate ? translate(format.labelKey) : format.label;

    return {
      text: label,
      value: format.value,
      example: now.format(format.pattern),
    };
  });
};
